import { createContext, useContext } from 'react';

export const HighlightedSearchContext = createContext('');

export const useSearchContext = (): [string, string[]] => {
  const search = useContext(HighlightedSearchContext);

  return [search, [...new Set(search.split(/ +/).filter(Boolean))]];
};
